import api from './apiHelper';

export const getPromotionCodeValidation = (propertyId, promotionCode) => {
  return api.get(`/booking-engine/promotion/${promotionCode}/validate`, { params: { propertyId } });
};

export const getBookingTotalPriceAfterPromotion = ({ promotionCode, propertyId, rooms, startDate, endDate }) => {
  return api.post(`/booking-engine/promotion/totalPriceAfterPromotion`, { promotionCode, propertyId, rooms, startDate, endDate });
};
